import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";

const initialState:any=[];

const productSlice = createSlice(
    {
        name:"product",
        initialState : initialState,
        reducers:{resetProduct: () => initialState},
        extraReducers: (builder: ActionReducerMapBuilder<any>) => {


          }
    }
);

const { reducer } = productSlice;
export const { resetProduct } = productSlice.actions;

export default reducer;
